/*eslint-disable*/
import React, { useState, useEffect, useRef } from "react";
import Highlighter from "react-highlight-words";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Input,
  Typography,
  Popover,
  Button,
  Modal,
  Spin,
  Space,
  Select,
  Row,
  Popconfirm,
  Divider,
  message,
  Checkbox,
  InputNumber,
} from "antd";
import {
  SearchOutlined,
  PlusOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  getAllProjects,
  createProject,
  deleteProject,
  updateProject,
  publishedProject,
} from "../Actions/projectsAction";
import { PermissionWrapper } from "../components/PermissionWrapper";
import MyTable from "../components/table";
import { ViewResidentialProjects } from "../pages/ViewResidentialProjects";
import { UpdateResidentialProjects } from "../pages/updateResidentialProjects";
import "./styles/clients.css";
import { useBreakpoints } from "../components/ResponsiveBreakPoints";
import useColumnSearch from "../Utils/useColumnSearch";
const Parking = [
  { value: 0, label: "No Parking" },
  { value: 1, label: "Parking 1" },
  { value: 2, label: "Parking 2" },
  { value: 3, label: "Parking 3" },
];
const schema = Yup.object().shape({
  property_name: Yup.string().required("Required"),
  tag_line: Yup.string().required("Required"),
  builder: Yup.string().required("Required"),
  no_of_floor: Yup.number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required("Required"),
  possesion: Yup.string().required("Required"),
  parking: Yup.string().required("Required"),
});
const { Text, Title } = Typography;

const ResidentialProperties = () => {
  const dispatch = useDispatch();
  const { isMobile } = useBreakpoints();
  const {
    projects,
    isGetProjectsLoading,
    isCreateProjectLoading,
    isUpdateProjectLoading,
    isDeleteProjectLoading,
  } = useSelector((state) => {
    const {
      projects,
      isGetProjectsLoading,
      isCreateProjectLoading,
      isUpdateProjectLoading,
      isDeleteProjectLoading,
    } = state.projects;
    return {
      projects,
      isGetProjectsLoading,
      isCreateProjectLoading,
      isUpdateProjectLoading,
      isDeleteProjectLoading,
    };
  });
  useEffect(() => {
    dispatch(getAllProjects("type=Residential"));
  }, []);

  const {
    register,
    handleSubmit,
    errors,
    clearErrors,
    control,
    reset,
    setValue,
    setError,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      pre_lease: false,
      pre_launch: false,
      is_sell: false,
      new_34: false,
      new_3: false,
    },
    mode: "onChange",
  });
  const [files, setFiles] = useState([]);
  const [name, setName] = useState("");
  const [brochurePdf, setBrochurePdf] = useState(null);

  const [createDialog, setCreateDialog] = useState(false);
  const pdfInputRef = useRef(null);
  const [description, setDescription] = useState([
    { key: "", value: "", id: Math.random() },
  ]);
  const handleCreateProject = (data, event) => {
    // event.preventDefault();
    data.image_url = files.length > 0 ? files : null;
    data.project_pdf = brochurePdf ? brochurePdf : null;
    data.project_type = "Residential";
    data.description = { description };
    dispatch(
      createProject(
        data,
        "type=Residential",
        successCreateArea,
        failureCreateArea,
      ),
    );
  };
  const successCreateArea = () => {
    setFiles([]);
    setBrochurePdf(null);
    setName("");
    setDescription([{ key: "", value: "" }]);
    setCreateDialog(false);
    reset({
      property_name: "",
      no_of_floor: "",
      area_id: "",
      image_one: "",
      builder: "",
      tag_line: "",
      possesion: "",
      parking: "",
      bhk: "",
      price_range: "",
      pre_lease: false,
      pre_launch: false,
      is_sell: false,
      new_34: false,
      new_3: false,
    });
    setTimeout(() => {
      message.success("You have successfully create residential projects.");
    }, 2000);
  };
  const failureCreateArea = () => {
    setTimeout(() => {
      message.info("Something went wrong.");
    }, 2000);
    setCreateDialog(false);
    reset();
  };
  const handleAdd = () => {
    const newDescription = description.concat([
      { key: "", value: "", id: Math.random() },
    ]);
    setDescription(newDescription);
  };
  const handleRemove = (id) => {
    const newDescription = description.filter((x) => x.id !== id);
    setDescription(newDescription);
  };
  const handleOnChange = (e, index) => {
    const { name, value } = e.target;
    const newDescription = description;
    const selectedObject = newDescription[index];
    selectedObject[name] = value;

    setDescription(newDescription);
  };
  const handleCancel = () => {
    reset({
      property_name: "",
      no_of_floor: "",
      area_id: "",
      image_one: "",
      builder: "",
      tag_line: "",
      possesion: "",
      parking: "",
      bhk: "",
      price_range: "",
      pre_lease: false,
      pre_launch: false,
      is_sell: false,
      new_34: false,
      new_3: false,
      new_sequence: "",
    });
    if (pdfInputRef.current) {
      pdfInputRef.current.value = "";
    }
    setFiles([]);
    setBrochurePdf(null);
    setName("");
    clearErrors([
      "property_name",
      "no_of_floor",
      "area_id",
      "image_one",
      "builder",
      "tag_line",
      "possesion",
      "parking",
      "bhk",
      "price_range",
      "pre_lease",
      "pre_launch",
      "is_sell",
      "new_34",
      "new_3",
      "new_sequence",
    ]);
    setDescription([{ key: "", value: "" }]);
    setCreateDialog(false);
  };
  const handleImageChange = (event) => {
    const { value } = event.target;
    const files = Array.from(event.target.files);
    setName(value);
    setFiles(files);
  };

  return (
    <Spin
      spinning={
        isGetProjectsLoading ||
        isCreateProjectLoading ||
        isUpdateProjectLoading ||
        isDeleteProjectLoading
      }
    >
      <Modal
        title="Create Residential Project"
        open={createDialog}
        onCancel={handleCancel}
        footer={null}
        maskClosable={false}
      >
        <form onSubmit={handleSubmit(handleCreateProject)}>
          <Row gutter={[8, 16]}>
            {files.length > 0 &&
              files?.map((image, index) => (
                <div key={index} style={{ margin: "10px" }}>
                  <img
                    src={URL.createObjectURL(image)}
                    alt={`image-${index}`}
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              ))}
            <Col>
              <input
                name="image_url"
                value={name}
                onChange={(e) => handleImageChange(e)}
                multiple
                type="file"
              ></input>
            </Col>
            <Col span={24}>
              <Row>
                <Text>Upload Brochure (PDF)</Text>
              </Row>

              <input
                ref={pdfInputRef}
                type="file"
                accept="application/pdf"
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file && file.type === "application/pdf") {
                    setBrochurePdf(file);
                  } else {
                    message.error("Please upload a valid PDF file");
                    e.target.value = "";
                  }
                }}
              />
            </Col>
            <Col span={24}></Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Project Name</Text>
              </Row>
              <Controller
                as={Input}
                name="property_name"
                control={control}
                placeholder="Property Name."
              />
              {errors.property_name && (
                <span className="error_style">Property Name is required</span>
              )}
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Builder</Text>
              </Row>
              <Controller
                as={Input}
                name="builder"
                control={control}
                placeholder="Builder"
              />
              {errors.builder && (
                <span className="error_style">Builder is required</span>
              )}
            </Col>
          </Row>

          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>No of Storey</Text>
              </Row>
              <Controller
                as={Input}
                name="no_of_floor"
                control={control}
                placeholder="No of Storey"
              />
              {errors.no_of_floor && (
                <span className="error_style">No of Storey is required</span>
              )}
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Area</Text>
              </Row>
              <Controller
                as={Input}
                name="area_name"
                control={control}
                placeholder="Enter area"
              />
              {errors.area_name && (
                <span className="error_style">Area is required</span>
              )}
            </Col>
          </Row>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Tag Line</Text>
              </Row>
              <Controller
                as={Input}
                name="tag_line"
                control={control}
                placeholder="Tag Line"
              />
              {errors.tag_line && (
                <span className="error_style">Tag Line is required</span>
              )}
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Possesion</Text>
              </Row>
              <Controller
                as={Input}
                name="possesion"
                control={control}
                placeholder="Possesion"
              />
              {errors.possesion && (
                <span className="error_style">possesion is required</span>
              )}
            </Col>
          </Row>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>BHK</Text>
              </Row>
              <Controller
                as={Input}
                name="bhk"
                control={control}
                placeholder="Enter BHK"
              />
              {/* {errors.tag_line && (
                <span className="error_style">Tag Lin is required</span>
              )} */}
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Price Range</Text>
              </Row>
              <Controller
                as={Input}
                name="price_range"
                control={control}
                placeholder="Enter Price Range 1cr - 5cr"
              />
            </Col>
          </Row>
          <Row gutter={[8, 16]} align="middle">
            <Col span={24}></Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Parking ?</Text>
              </Row>
              <Controller
                as={Select}
                control={control}
                options={Parking}
                name="parking"
                style={{ width: "100%" }}
              />
              {errors.parking && (
                <span className="error_style">Parking is required</span>
              )}
            </Col>

            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Total Units</Text>
              </Row>
              <Controller
                as={Input}
                name="total_units"
                control={control}
                placeholder="Enter total units"
              />
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Sequence</Text>
              </Row>
              <Controller
                as={<InputNumber style={{ width: "100%" }} />}
                name="new_sequence"
                control={control}
                placeholder="Enter Sequence"
              />
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Latitude</Text>
              </Row>
              <Controller
                as={<InputNumber style={{ width: "100%" }} />}
                name="latitude"
                control={control}
                placeholder="Enter Latitude"
              />
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Longitude</Text>
              </Row>
              <Controller
                as={<InputNumber style={{ width: "100%" }} />}
                name="longitude"
                control={control}
                placeholder="Enter Longitude"
              />
            </Col>

            {/* Changed Pre launch to New 4/5, Pre lease to New 3/4 and For sale to Resell  */}
            <Col>
              <Row gutter={[30, 0]}>
                <Col>
                  <Row gutter={[10, 0]}>
                    <Col>
                      <Text>New 4/5</Text>
                    </Col>
                    <Col>
                      <Controller
                        name="pre_launch"
                        control={control}
                        render={(props) => (
                          <Checkbox
                            {...props}
                            defaultValue={false}
                            checked={props.value}
                            onChange={(e) => props.onChange(e.target.checked)}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Row gutter={[10, 0]}>
                    <Col>
                      <Text>New 3/4</Text>
                    </Col>
                    <Col>
                      <Controller
                        name="new_34"
                        control={control}
                        render={(props) => (
                          <Checkbox
                            {...props}
                            defaultValue={false}
                            checked={props.value}
                            onChange={(e) => props.onChange(e.target.checked)}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Row gutter={[10, 0]}>
                    <Col>
                      <Text>New 3</Text>
                    </Col>
                    <Col>
                      <Controller
                        name="new_3"
                        control={control}
                        render={(props) => (
                          <Checkbox
                            {...props}
                            defaultValue={false}
                            checked={props.value}
                            onChange={(e) => props.onChange(e.target.checked)}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
                {/* <Col>
                  <Row gutter={[10, 0]}>
                    <Col>
                      <Text>Resell</Text>
                    </Col>
                    <Col>
                      <Controller
                        name="pre_lease"
                        control={control}
                        render={(props) => (
                          <Checkbox
                            {...props}
                            checked={props.value}
                            onChange={(e) => props.onChange(e.target.checked)}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col> */}
                <Col>
                  <Row gutter={[10, 0]}>
                    <Col>
                      <Text>Resell</Text>
                    </Col>
                    <Col>
                      <Controller
                        name="is_sell"
                        control={control}
                        render={(props) => (
                          <Checkbox
                            {...props}
                            defaultValue={false}
                            checked={props.value}
                            onChange={(e) => props.onChange(e.target.checked)}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>

          <Divider />
          <Row>
            <Button onClick={handleAdd} type="primary" icon={<PlusOutlined />}>
              Add
            </Button>
          </Row>

          {description.map((des, index) => {
            return (
              <Row key={index} gutter={[8, 16]}>
                <Col span={24}></Col>
                <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                  <Row>
                    <Text>Key</Text>
                  </Row>
                  <Input
                    key={des.id}
                    name={`key`}
                    onChange={(e) => handleOnChange(e, index)}
                    placeholder="e.g. 3BHK, 4BHK Pent house"
                  />
                  {/* {errors.description && (
                  <span className="error_style">Type Of BHK is required</span>
                )} */}
                </Col>
                <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                  <Row>
                    <Text>value</Text>
                  </Row>
                  <Input
                    key={des.id}
                    name={`value`}
                    onChange={(e) => handleOnChange(e, index)}
                    placeholder="e.g. 2500.Sqft"
                  />
                  {/* {errors.description && (
                  <span className="error_style">Type Of BHK is required</span>
                )} */}
                </Col>
                {index !== 0 && (
                  <Button type="link" onClick={() => handleRemove(des.id)}>
                    Remove
                  </Button>
                )}
              </Row>
            );
          })}

          <Row justify="end" gutter={[0, 16]}>
            <Col span={24}></Col>
            <Col>
              {isCreateProjectLoading ? (
                <Spin
                  indicator={
                    <LoadingOutlined
                      style={{
                        fontSize: 24,
                      }}
                      spin
                    />
                  }
                />
              ) : (
                <Button type="primary" htmlType="submit">
                  Create Project
                </Button>
              )}
            </Col>
          </Row>
        </form>
      </Modal>
      {projects && (
        <AllResidentialProperties
          data={projects}
          handleDialog={() => {
            setCreateDialog(true);
          }}
        />
      )}
      {/* {projects && <AllProperties data={projects} />} */}
    </Spin>
  );
};
export default ResidentialProperties;

const AllResidentialProperties = (props) => {
  const { getColumnSearchProps } = useColumnSearch();
  const { currentUser } = useSelector((state) => state.users);
  const isAdmin = currentUser?.role === "Admin";
  const { handleDialog } = props;
  const [showSearch, setShowSearch] = useState(false);
  const [currentProject, setCurrentProject] = useState({});
  const onRowSelect = (record) => {
    setCurrentProject(record);
    setShowSearch(true);
  };
  // useEffect(() => {
  //   if (createProject !== {}) {
  //     // dispatch() getTasks
  //     // dispatch() getSearch Properies
  //   }
  // }, [currentProject]);

  const columns = () => [
    {
      title: "Project Name",
      width: 120,
      dataIndex: "property_name",
      key: "1",
      // fixed: "left",
    },
    {
      title: "Project Type",
      key: "status",
      width: 120,

      filters: [
        { text: "New 4/5", value: "pre_launch" },
        { text: "New 3/4", value: "new_34" },
        { text: "New 3", value: "new_3" },
        { text: "Resell", value: "is_sell" },
      ],

      onFilter: (value, record) => {
        return record?.[value] === true;
      },

      render: (record, row) => {
        return (
          <div>
            {row.pre_launch && <span>New 4/5&nbsp;</span>}
            {row.new_34 && <span>New 3/4&nbsp;</span>}
            {row.new_3 && <span>New 3&nbsp;</span>}
            {row.is_sell && <span>Resell</span>}
          </div>
        );
      },
    },
    {
      title: "Sequence",
      width: 80,
      dataIndex: "new_sequence",
      render: (record) => {
        return <div>{record || "-"}</div>;
      },
    },
    {
      title: "Tag Line",
      width: 150,
      dataIndex: "tag_line",
      key: "2",
      // fixed: "left",
    },
    {
      title: "Builder",
      width: 100,
      dataIndex: "builder",
      key: "3",
      // fixed: "left",
    },
    {
      title: "No Of Storey",
      width: 80,
      dataIndex: "no_of_floor",
      key: "4",
      // fixed: "left",
    },
    {
      title: "Possesion",
      dataIndex: "possesion",
      key: "5",
      width: 100,
    },
    {
      title: "Parking",
      dataIndex: "parking",
      key: "6",
      width: 150,
    },
    {
      title: "Area",
      dataIndex: "area_name",
      width: 100,
      key: "7",
      render: (record, object) => {
        return <div>{record || ""}</div>;
      },
    },
    {
      title: "id",
      width: 90,
      dataIndex: "id",
      key: "8",
      ...getColumnSearchProps("id"),
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      fixed: "right",
      width: 100,
      render: (id) => (
        <ActionComponent
          key={id}
          id={id}
          type="type=Residential"
          published={currentProject.published}
        />
      ),
    },
  ];
  return (
    <>
      <Row className="rowWithPadding" justify="space-between">
        <Col>
          <Title level={4}>All Residential Projects({props.data.length})</Title>
        </Col>
        <Col>
          <PermissionWrapper
            resource="projects_residential"
            action="create"
            disabled={true}
          >
            <Button type="primary" onClick={() => handleDialog()}>
              Create Residential Project
            </Button>
          </PermissionWrapper>
        </Col>
      </Row>
      <MyTable
        columns={columns()}
        data={props.data}
        onRowSelect={(record) => onRowSelect(record)}
      />
    </>
  );
};
const ActionComponent = ({ id, type, published }) => {
  const [popoverVisible, setPopoverVisible] = useState(false);
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.users);
  const isAdmin = currentUser?.role === "Admin";
  // const handleDeleteResidentialProject = (id,type) => {
  //   setTimeout(() => {
  //     message.success("Delete Residential Project successful.");
  //   }, 1000);
  //   dispatch(deleteProject(id,type));
  // };
  const handleDeleteResidentialProject = (project_id) => {
    project_id = id;
    dispatch(
      deleteProject(
        project_id,
        "type=Residential",
        successDeleteResidentialProject,
        failureDeleteResidentialProject,
      ),
    );
  };

  const successDeleteResidentialProject = () => {
    setTimeout(() => {
      message.success("You have successfully delete residential projects.");
    }, 2000);
  };
  const failureDeleteResidentialProject = () => {
    setTimeout(() => {
      message.info("Something went wrong.");
    }, 2000);
  };
  const handleUpdatePublished = () => {
    // event.preventDefault();
    setPopoverVisible(false);
    dispatch(publishedProject(id, type, true));
  };
  const handleUpdateUnPublished = () => {
    // event.preventDefault();
    setPopoverVisible(false);
    dispatch(publishedProject(id, type, false));
  };
  const content = (
    <div>
      {/* <ViewProperty id={id} />
      &nbsp;&nbsp; */}
      &nbsp;&nbsp;
      <PermissionWrapper
        resource="projects_residential"
        action="show"
        disabled={true}
      >
        <ViewResidentialProjects
          id={id}
          setPopoverVisible={setPopoverVisible}
        />
      </PermissionWrapper>
      &nbsp;&nbsp;
      <PermissionWrapper
        resource="projects_residential"
        action="update"
        disabled={true}
      >
        {published ? (
          <Button type="link" onClick={() => handleUpdateUnPublished()}>
            Un Published
          </Button>
        ) : (
          <Button type="link" onClick={() => handleUpdatePublished()}>
            Published
          </Button>
        )}
      </PermissionWrapper>
      &nbsp;&nbsp;
      <PermissionWrapper
        resource="projects_residential"
        action="update"
        disabled={true}
      >
        <UpdateResidentialProjects
          id={id}
          setPopoverVisible={setPopoverVisible}
        />
      </PermissionWrapper>
      &nbsp;&nbsp;
      <PermissionWrapper
        resource="projects_residential"
        action="destroy"
        disabled={true}
      >
        <Popconfirm
          title="Sure to delete?"
          // onConfirm={() => dispatch(deleteProject(id, type))}
          onConfirm={() => handleDeleteResidentialProject(id, type)}
        >
          <Button type="link" onClick={() => setPopoverVisible(false)}>
            Delete
          </Button>
        </Popconfirm>
      </PermissionWrapper>
    </div>
  );
  return (
    <Popover
      content={content}
      open={popoverVisible}
      trigger="click"
      onOpenChange={setPopoverVisible}
    >
      <Button type="link" onClick={() => setPopoverVisible(!popoverVisible)}>
        Action
      </Button>
    </Popover>
  );
};
